import React from 'react';

const Presentation = () => {
  return (
    <div style={{ width: '100%', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
      <iframe
        src="https://fitoses-imzozul.gamma.site/"
        title="Fitos.es"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block'
        }}
        allowFullScreen
      />
    </div>
  );
};

export default Presentation;

